module.exports = __webpack_public_path__ + "static/media/cpp_logo.8f42e018.png";